export default "__VITE_ASSET__DLKUBJDG__"